class BootConfig {
  i18nLoadPath(): string {
    return `/locales/{{lng}}/{{ns}}.json`;
  }
}

export const config = new BootConfig();
